import { AxiosInstance, AxiosRequestConfig } from 'axios';
import storage from 'commons/utils/storage';
import { decode } from 'commons/utils/auth/jwt';
import { EventType, sendEvent } from 'commons/utils/event';
import { INVALID_USER_MESSAGE, LOGIN_ROUTE } from 'commons/constants/app';
import { REDIRECT_AFTER_AUTH, REFRESH_TOKEN, TOKEN } from 'commons/constants/store';
import { isTokenExpired } from 'commons/utils/auth/auth';
import authApi from 'services/auth';

type RequestRetryCallBack = (token: string) => void;

let isRefreshing = false;
let subscribers: RequestRetryCallBack[] = [];

function subscribeTokenRefresh(cb: RequestRetryCallBack) {
  subscribers.push(cb);
}

function onRefreshed(token: string) {
  subscribers.map(cb => cb(token));
  subscribers = [];
}

function tryToRefreshToken(client: AxiosInstance, requestToRetry: AxiosRequestConfig) {
  const refreshToken: string = storage.get(REFRESH_TOKEN);
  const decodedRefreshToken = decode(refreshToken);

  if (isTokenExpired(decodedRefreshToken?.exp)) {
    // salvar a rota atual para redirecionar o usuário após o login
    storage.add(REDIRECT_AFTER_AUTH, window.location.pathname + window.location.search + window.location.hash);
    storage.clearExcept(REDIRECT_AFTER_AUTH);
    location.assign(LOGIN_ROUTE);
    return Promise.reject({ status: 401, message: INVALID_USER_MESSAGE });
  }

  if (!isRefreshing) {
    isRefreshing = true;
    authApi
      .refreshToken()
      .then(newToken => {
        storage.add(TOKEN, newToken.data.accessToken);
        sendEvent(EventType.SET_USER, newToken);

        onRefreshed(newToken.data.accessToken);
        isRefreshing = false;
      })
      .catch(() => {
        // fluxo de refresh falhou, então vamos limpar o storage e redirecionar para login
        isRefreshing = false;
        subscribers = [];
        storage.add(REDIRECT_AFTER_AUTH, window.location.pathname + window.location.search + window.location.hash);
        storage.clearExcept(REDIRECT_AFTER_AUTH);
        location.assign(LOGIN_ROUTE);
      });
  }

  const requestSubscribers = new Promise(resolve => {
    subscribeTokenRefresh(token => {
      requestToRetry.headers = { ...requestToRetry.headers, Authorization: 'Bearer ' + token };
      resolve(client(requestToRetry));
    });
  });

  return requestSubscribers;
}
export { tryToRefreshToken };
